var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2H5V14H3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.975 11.8148L21.2638 7.73505C20.6868 4.42561 17.692 2 14.1827 2H9.00626C7.90169 2 7.00626 2.89543 7.00626 4V12.9156C6.95973 13.4494 7.17448 13.9729 7.58339 14.3225L9.03367 15.5623C9.70656 16.1375 10.3539 16.7598 10.7726 17.5374C11.0591 18.0695 11.2814 18.6328 11.434 19.2163L11.9135 21.0501C12.0063 21.4053 12.2569 21.7039 12.5994 21.8676C12.9105 22.0163 13.2707 22.0408 13.6007 21.9356L13.7469 21.8891C14.2929 21.715 14.7081 21.2864 14.8478 20.7525C15.0163 20.108 15.0473 19.4357 14.9387 18.7786L14.2708 14.734C14.187 14.2267 14.5811 13.7658 15.0988 13.7658H20.3214C21.3627 13.7658 22.1526 12.8338 21.975 11.8148Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.3d217a22a7a5305c3911331f71d8daaf.svg";
export { ForwardRef as ReactComponent };